<script lang="ts">
import { computed } from 'vue'
import AdaptationsReference from './AdaptationsReference.vue'
import AlchemicalIngredient from './AlchemicalIngredient.vue'
import ExampleCharacterBase from './ExampleCharacterBase.vue'
import NewPlayerGuide from './NewPlayerGuide.vue'
import RollingDice from './RollingDice.vue'
import StatusEffectsTable from './StatusEffectsTable.vue'
import { useDesignStore } from '@/stores/designStore.ts'
import SpellReference from './SpellReference.vue'
import WeaponTable from './WeaponTable.vue'

export default {
  props: ['title'],
  setup(props, context) {
    const designStore = useDesignStore()
    const character = computed(() => {
      return props.title.split(': ')[1]
    })
    return {
      designStore,
      character,
      props
    }
  },
  components: {
    AlchemicalIngredient,
    AdaptationsReference,
    NewPlayerGuide,
    RollingDice,
    StatusEffectsTable,
    ExampleCharacterBase,
    SpellReference,
    WeaponTable
  }
}
</script>

<template>
  <div>
    <div v-if="props.title === 'Alchemical Ingredients'">
      <AlchemicalIngredient></AlchemicalIngredient>
    </div>
    <div v-if="props.title === 'Adaptations'">
      <AdaptationsReference></AdaptationsReference>
    </div>
    <div v-if="props.title === 'New Player Guide'">
      <NewPlayerGuide></NewPlayerGuide>
    </div>
    <div v-if="props.title === 'Rolling Dice'">
      <RollingDice></RollingDice>
    </div>
    <div v-if="props.title === 'Status Effect'">
      <StatusEffectsTable></StatusEffectsTable>
    </div>
    <div v-if="props.title.includes('Example Character:')">
      <ExampleCharacterBase :character="character"></ExampleCharacterBase>
    </div>
    <div v-if="props.title === 'Spell'">
      <SpellReference></SpellReference>
    </div>
    <div v-if="props.title === 'Weapons Table'">
      <WeaponTable title="Weapons"></WeaponTable>
    </div>
  </div>
</template>

<style>
.rulesReferenceContainer {
  display: flex;
}
</style>
